import { useState, useEffect } from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import Switch from "../../../../../../../../components/Switch";
import {
  get_tags_config,
  create_tags_config,
} from "../../../../../../../../API/TagsSettings";
import CustomToast from "../../../../../../../../components/CustomToast";
import { useNavigate } from "react-router";
import Icon from "../../../../../../../../components/Icon";

const Row = ({ item, activeTable, activeId }) => {
  const navigate = useNavigate();
  const showToast = CustomToast();
  const [localToggleState, setLocalToggleState] = useState({});
  const [isHovered, setIsHovered] = useState(false);

  const fetchTagConfig = async () => {
    const res = await get_tags_config();
    const initialToggleState = {};
    res.data.forEach((config) => {
      initialToggleState[config.tag_settings_id] = config.isActive;
    });
    setLocalToggleState(initialToggleState);
  };

  const handleSettingChange = async (tag) => {
    const currentActiveState = localToggleState[tag.id] || false;

    try {
      const formData = {
        tag_settings_id: tag.id,
        store_id: tag.store_id,
        isActive: !currentActiveState,
      };

      setLocalToggleState((prevState) => ({
        ...prevState,
        [tag.id]: !currentActiveState,
      }));

      await create_tags_config(formData);
    } catch (error) {
      setLocalToggleState((prevState) => ({
        ...prevState,
        [tag.id]: currentActiveState,
      }));

      if (error?.response?.data?.err) {
        showToast(error.response.data.err, "error");
      } else {
        showToast("Failed to update settings", "error");
      }
    }
  };

  const handleViewCategory = (tag) => {
    if (localToggleState[tag.id]) {
      navigate(`/settingsDashboard/tags/${tag.id}`, { state: { tag } });
    }
  };

  useEffect(() => {
    fetchTagConfig();
  }, []);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={cn(
        styles.row,
        { [styles.selected]: activeId === item.id },
        { [styles.active]: activeTable }
      )}
    >
      <div className={styles.col}>
        <div className={styles.tagWrapper}>
          <div  className={cn("bg-[#EFEFEF] p-4 rounded-lg",styles.tagblock)}> <Icon name="tag" size="32" fill="#2A85FF" /></div>
          <div className={styles.email}>{item.name}</div>
        </div>
      </div>
      <div className={styles.col}> </div>
      <div className={styles.col}> </div>
      <div className={styles.col}>
        {isHovered && localToggleState[item.id] && (
          <div className={cn("flex w-1/2 bg-white rounded-[13px] p-[10px_20px]",styles.editblock)} onClick={() => handleViewCategory(item)} >
            <Icon name="edit" size="24"/> 
            <div className={cn("ml-[15px]")}>Edit tag</div>
          </div>
        )}
      </div>
      <div className={styles.col}>
        <Switch
          className={styles.checkbox}
          content={item.name}
          value={localToggleState[item.id] || false}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            e.stopPropagation();
            handleSettingChange(item);
          }}
        />
      </div>
    </div>
  );
};

export default Row;
